define('views/layouts/layout-app',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // src
    'services/layout',
    'src/queue/delay-queue',
    // Views
    'views/layouts/layout-overlay',
    'views/layouts/layout-overlay-stack',
    'views/layouts/content/layout-content',
    'views/layouts/layout-menu',
    // Templates
    'text!templates/layouts/layout-app.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // custom
    LayoutState,
    DelayQueue,
    // Views
    VLayoutOverlay,
    VLayoutOverlayStack,
    VLayoutContent,
    VLayoutMenu,
    // Templates
    TLayoutApp
) {

    var VLayoutApp = Backbone.View.extend({
        template: TLayoutApp,
        id: "app-content",
        className: function() {
            return "layout " + "layout-" + this.role;
        },
        regions: {
            menu: '#menu',
            drawer: '#menu-drawer',
            content: '#content-section',
        },

        constructor: function(options) {
            this.queue = {
                drawer: new DelayQueue({ delay: 200, context: this }),
                menu: new DelayQueue({ delay: 200, context: this })
            };

            // Inistialize Views
            var view = this._view = {
                content: new VLayoutContent(),
                menu: new VLayoutMenu({
                    context: this,
                    role: options.role,
                    group: options.group,
                    onClick: this.onMenuClick
                }),
                drawer: new VLayoutOverlayStack()
            };

            Backbone.View.apply(this, arguments);

            this.listenTo(LayoutState, {
                "toggle:menu.drawer": this.toggleMenuDrawer,
                "view:menu.drawer": this.setMenuDrawerContent,
            });
            this.listenTo(view.drawer, {
                'back': this.onBack
            });
        },

        // to override
        initialize: _.noop,

        render: function() {
            this.$el.empty()
                .append(Mustache.render(this.template));

            this.generateZones()
                .renderView(['menu', 'drawer', 'content'], this._view);
            // .assign(this.getDrawer(), this.zone.$drawer);

            this.updateProfileMenu();

            return this;
        },

        getContent: function() {
            return this._view.content;
        },

        getDrawer: function() {
            return this._view.drawer;
        },

        getMenu: function() {
            return this._view.menu;
        },

        /////////////////
        // Menu drawer //
        /////////////////
        isMenuDrawerOpened: function() {
            return this.zone && this.zone.$drawer.hasClass('open');
        },
        /**
         * The menu-drawer takes T seconds to open/close where T is defined in
         * the CSS as a transition. In order to provide queued promises after
         * each step of the transition, we use a custom DelayQueue class.
         */
        toggleMenuDrawer: function(open) {
            return this.queue.drawer.add(this._toggleMenuDrawer, open, {
                    condition: function() {
                        return this.isMenuDrawerOpened() !== open;
                    }
                })
                .done(this._afterMenuDrawerToggle);
        },
        // the callback for the queued promise.
        _toggleMenuDrawer: function(open) {
            if (this.zone) {
                this.zone.$drawer.toggleClass('open', open);
                if (!this.isMenuDrawerOpened()) this.getMenu().deactivate();
            }
        },
        _afterMenuDrawerToggle: function() {
            // trigger an event after as a hook for other views
            LayoutState.setState('menu.drawer', this.isMenuDrawerOpened());
        },

        setMenuDrawerContent: function(view, open) {
            var isOpened = this.isMenuDrawerOpened(),
                drawer = this.getDrawer();

            if (drawer.is(view)) {
                if (!isOpened) {
                    this.toggleMenuDrawer();
                }
            } else {
                drawer.set(view, open).always(function() {
                    this.toggleMenuDrawer(open !== false);
                }.bind(this));
            }

        },

        _setMenuDrawerContent: function(view, open) {
            // open the overlay
            this._view.drawer.toggle(true);
            // inform the opening view
            view.onOpen(open);
            // defer opening the panel pushing the page content
            this.toggleMenuDrawer(open);
        },

        reset: function() {
            if (this.zone) {
                this.toggleMenuDrawer(false);
                this.toggleMenu(false);
            }
        },

        ////////////
        // events //
        ////////////

        onMenuClick: _.noop,
        onBack: function() {
            this.toggleMenuDrawer(false);
        }

    });

    return VLayoutApp;

});

